import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Swiftdzireonrentmumbai() {



  const cardData = {
    keyword: " Swift Dzire on Rent in Mumbai ",


"headingDescription": "Royal Route Cab offers affordable and comfortable Swift Dzire on rent in Mumbai, making it an ideal choice for city travel, airport transfers, corporate rides, and outstation journeys. The Swift Dzire is one of the most preferred sedan cars due to its excellent mileage, spacious interiors, and smooth driving experience in Mumbai traffic. Our professional drivers and well-maintained vehicles ensure a safe and hassle-free journey for individuals, families, and business travelers. The rental cost for Swift Dzire in Mumbai typically starts from around ₹12 to ₹13 per km depending on the trip type, making it a budget-friendly option for all travel needs. :contentReference[oaicite:0]{index=0} We offer flexible booking options including one-way, round trip, and hourly rental packages with transparent pricing and no hidden charges. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted choice for Swift Dzire rental in Mumbai.",

"topPlaces": [
 
  {
    "title": "Matheran",
    "description": "Matheran is a charming eco-friendly hill station where vehicles are not allowed, offering a peaceful environment, toy train rides, forest trails, and stunning viewpoints. It is one of the most relaxing destinations near Mumbai."
  },
   {
    "title": "Lonavala",
    "description": "Lonavala is one of the closest and most popular tourist destinations near Mumbai, known for its lush green hills, waterfalls, and scenic viewpoints. Attractions such as Bhushi Dam, Tiger’s Leap, and Rajmachi Point make it an ideal weekend getaway."
  },
  {
    "title": "Khandala",
    "description": "Khandala is a beautiful hill station located near Mumbai, famous for its mist-covered valleys, winding roads, and panoramic mountain views. It is a favorite destination for nature lovers and road trip enthusiasts."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a popular coastal town near Mumbai known for its clean beaches, sea forts, and relaxing atmosphere. Visitors enjoy beach activities, seafood, and attractions such as Kolaba Fort and Alibaug Beach."
  },
  {
    "title": "Karnala Bird Sanctuary",
    "description": "Karnala Bird Sanctuary is a nature lover’s paradise located near Mumbai, offering trekking trails, rich biodiversity, and the historic Karnala Fort. It is a great destination for wildlife enthusiasts and photographers."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a scenic hill station surrounded by the Sahyadri mountains, famous for waterfalls, lush greenery, and peaceful surroundings. It is especially popular during the monsoon season."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is a picturesque destination near Mumbai known for lakeside camping, beautiful sunsets, and breathtaking mountain views. It is a favorite spot for weekend picnics and overnight camping experiences."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic trekking destination near Mumbai offering stunning views of the Sahyadri ranges. It attracts adventure enthusiasts, trekkers, and history lovers throughout the year."
  },
  {
    "title": "Imagicaa Theme Park",
    "description": "Imagicaa Theme Park is one of India's leading entertainment destinations near Mumbai, featuring thrilling rides, water attractions, and family-friendly activities suitable for all age groups."
  },
  {
    "title": "Kaas Plateau",
    "description": "Kaas Plateau, often called the Valley of Flowers of Maharashtra, is famous for its seasonal blooms and breathtaking natural beauty. It is a popular destination for nature lovers and photography enthusiasts."
  }
],






services: [
  {
    name: "Swift Dzire on Rent Mumbai",
    description: "Swift Dzire on rent Mumbai offers a perfect combination of comfort, affordability, and fuel efficiency for city and outstation travel. Ideal for individuals, couples, and small families, this sedan ensures smooth rides across Mumbai and beyond. Clean vehicles and professional drivers enhance the experience. It guarantees a comfortable and budget-friendly journey."
  },
  {
    name: "Dzire Cab Service Mumbai",
    description: "Dzire cab service Mumbai provides reliable transportation with well-maintained sedan cars. This service is ideal for local travel, airport transfers, and outstation trips. Professional drivers ensure safe and timely service. It ensures a smooth and hassle-free travel experience."
  },
  {
    name: "Dzire Taxi Rental Mumbai",
    description: "Dzire taxi rental Mumbai offers flexible rental options for daily, hourly, and outstation travel. This service is suitable for business trips and personal use. Vehicles are clean and driven by experienced chauffeurs. It ensures comfortable and convenient travel."
  },
  {
    name: "Maruti Dzire Cab Mumbai",
    description: "Maruti Dzire cab Mumbai provides economical and comfortable travel for short and long-distance journeys. This service is widely preferred for its mileage and smooth driving experience. Ideal for city rides and airport transfers. It ensures a reliable journey."
  },
  {
    name: "Dzire Car Hire Mumbai",
    description: "Dzire car hire Mumbai allows customers to rent a sedan for flexible travel needs. This service is ideal for personal trips, business travel, and family outings. Easy booking and transparent pricing enhance convenience. It ensures a pleasant journey."
  },
  {
    name: "Dzire Rental per KM Mumbai",
    description: "Dzire rental per km Mumbai offers cost-effective pricing based on distance traveled. This service is ideal for budget-conscious travelers. Transparent per km rates help in planning travel expenses. It ensures affordable and flexible travel solutions."
  },
  {
    name: "Dzire Cab Booking Mumbai",
    description: "Dzire cab booking Mumbai allows customers to reserve their ride easily with flexible options. Travelers can choose pickup location, timing, and travel plan. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Dzire Taxi Booking Online Mumbai",
    description: "Dzire taxi booking online Mumbai provides a quick and convenient way to book sedan cabs. Customers can compare options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Dzire Cab Price Mumbai",
    description: "Dzire cab price Mumbai varies based on trip type, distance, and duration. Transparent pricing ensures no hidden charges. Budget-friendly rates make it ideal for everyday travel. It helps travelers plan efficiently. It ensures value for money."
  },
  {
    name: "Dzire Taxi Fare Mumbai",
    description: "Dzire taxi fare Mumbai is designed to be affordable and competitive for city and outstation travel. Fare depends on vehicle usage and route. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Dzire One Way Cab Mumbai",
    description: "Dzire one way cab Mumbai is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for airport and outstation travel. It ensures smooth and economical travel."
  },
  {
    name: "Dzire Round Trip Cab Mumbai",
    description: "Dzire round trip cab Mumbai is ideal for travelers planning return journeys. This service includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family trips and business travel. It ensures comfort and efficiency."
  },
  {
    name: "Cheap Dzire Rental Mumbai",
    description: "Cheap Dzire rental Mumbai offers budget-friendly sedan options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Dzire Cab Service Mumbai",
    description: "Best Dzire cab service Mumbai ensures premium travel experience with well-maintained vehicles and professional drivers. This service focuses on punctuality, comfort, and customer satisfaction. It guarantees a reliable and smooth journey."
  },
  {
    name: "Dzire Airport Cab Mumbai",
    description: "Dzire airport cab Mumbai provides convenient pickup and drop services to Mumbai airport. This service ensures timely arrival and comfortable travel. Ideal for business travelers and tourists. Professional drivers ensure safe journeys. It guarantees a stress-free airport transfer."
  }
],

tableData: [
  ["Swift Dzire on Rent Mumbai", "Dzire Cab Service Mumbai"],
  ["Dzire Taxi Rental Mumbai", "Maruti Dzire Cab Mumbai"],
  ["Dzire Car Hire Mumbai", "Dzire Rental per KM Mumbai"],
  ["Dzire Cab Booking Mumbai", "Dzire Taxi Booking Online Mumbai"],
  ["Dzire Cab Price Mumbai", "Dzire Taxi Fare Mumbai"],
  ["Dzire One Way Cab Mumbai", "Dzire Round Trip Cab Mumbai"],
  ["Cheap Dzire Rental Mumbai", "Best Dzire Cab Service Mumbai"],
  ["Dzire Airport Cab Mumbai", "Swift Dzire on Rent Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable Swift Dzire on Rent in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly Swift Dzire rental in Mumbai, perfect for daily travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Comfortable & Fuel-Efficient Sedan",
    WhyChoosedescription: "Swift Dzire is known for its comfort, smooth ride, and excellent mileage, making it ideal for city and long-distance travel."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced, ensuring safe and hassle-free travel across Mumbai and beyond."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing for Dzire rental including all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Swift Dzire rental service in Mumbai is available 24/7 for flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Swift Dzire cars are regularly serviced, sanitized, and maintained for a comfortable ride experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Book Swift Dzire for local Mumbai travel, airport pickup-drop, or outstation trips with flexible packages."
  },
  {
    WhyChooseheading: "Trusted Sedan Rental Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Swift Dzire rental service in Mumbai with punctual drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Swift Dzire on rent in Mumbai?", answer: "Yes, Royal Route Cabs offers Swift Dzire rental services in Mumbai for local and outstation travel." },
  { question: "Is Swift Dzire suitable for outstation trips?", answer: "Yes, Swift Dzire is ideal for both city and long-distance travel due to its comfort and mileage." },
  { question: "Is Dzire rental available 24 hours?", answer: "Yes, our Swift Dzire rental service operates 24/7." },
  { question: "Do you provide driver with Dzire rental?", answer: "Yes, all rentals include professional drivers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide airport pickup with Dzire?", answer: "Yes, we offer Mumbai airport pickup and drop services with Swift Dzire." },
  { question: "Can I book Dzire for one-way trips?", answer: "Yes, we provide one-way and round-trip booking options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal More",
    feedback: "Swift Dzire on rent in Mumbai from Royal Route Cabs was a great choice. The car was clean, comfortable, and perfect for our city travel needs.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Shah",
    feedback: "Booked a Swift Dzire for local use in Mumbai and the experience was excellent. The vehicle condition was good and the service was punctual and reliable.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/swift-dzire-on-rent-mumbai.jpg", // replace if needed
  "description": "Book Swift Dzire on rent in Mumbai with Royal Route Cabs for affordable and comfortable travel. Available for local, airport, one-way, and round-trip trips. Best Dzire cab service with professional drivers and 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/swift-dzire-on-rent-mumbai"
  }
};







  return (
    <div>
<Helmet>
  <title>Swift Dzire on Rent in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Swift Dzire on rent in Mumbai with Royal Route Cabs. Affordable Dzire cab service for local, airport, and outstation travel. Safe, comfortable & 24x7 available."
  />

  <meta
    name="keywords"
    content="swift dzire on rent mumbai, dzire cab service mumbai, dzire taxi rental mumbai, maruti dzire cab mumbai, dzire car hire mumbai, dzire rental per km mumbai, dzire cab booking mumbai, dzire taxi booking online mumbai, dzire cab price mumbai, dzire taxi fare mumbai, dzire one way cab mumbai, dzire round trip cab mumbai, cheap dzire rental mumbai, best dzire cab service mumbai, dzire airport cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentmumbai;